import { Card, Col, Row, Button, Upload as UploadAntd, Form, message, Modal, Table, Input } from "antd";
import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import UploadIcon from "../../assets/images/upload-icon.svg";
import ModalDeleteIcon from "../../assets/images/delete-icon.svg";
import useRequest from "../../hooks/useRequest";
import apiPath from "../../constants/apiPath";
import { S3Client } from '@aws-sdk/client-s3';
import { Upload } from '@aws-sdk/lib-storage';
import EditTableIcon from "../../assets/images/edit-icon-table.svg";
import { DownloadOutlined, PlusOutlined, UploadOutlined } from "@ant-design/icons";

const s3Config = {
  region: 'us-east-1',
  credentials: {
    accessKeyId: "AKIAFBC97UM4I3ILWTIKQ",
    secretAccessKey: "vMUNWcZvMesuFfmUwdUYnsaOr1pp38wu8nOon8eb",
  },
  endpoint: "https://s3-noi.aces3.ai/",
  forcePathStyle: true,
  requestChecksumCalculation: "WHEN_REQUIRED",
  responseChecksumValidation: "WHEN_REQUIRED",
};
const s3Client = new S3Client(s3Config);

const stripHtml = (html) => {
  const doc = new DOMParser().parseFromString(html, "text/html");
  return doc.body.textContent || "";
};

function Home() {
  const [form] = Form.useForm();
  const [form1] = Form.useForm();

  // State for Add modal file
  const [file, setFile] = useState([]);
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);

  // State for Edit modal file
  const [fileEdit, setFileEdit] = useState([]);
  const [imageEdit, setImageEdit] = useState("");

  // Modal states
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalWebsiteOpen, setIsModalWebsiteOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [isModalContentOpen, setIsModalContentOpen] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [dataSource, setDataSource] = useState([]);
  const { request } = useRequest();

  const showModal = (text) => {
    setModalContent(text);
    setIsModalContentOpen(true);
  };

  const handleCancel = () => {
    setIsModalContentOpen(false);
  };

  // Table columns (basic example - adjust to your fields)
  const columns = [
    {
      title: 'File/Document',
      dataIndex: 'image',
      key: 'image',
      render: (text) => text ? <a className="main-new-document-clask" href={text} target="_blank" rel="noreferrer"><DownloadOutlined /> Export</a> : "No Document"
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
      render: (text) => (
        <p
          className="cap"
          style={{ cursor: "pointer", color: "#1677ff", margin: 0 }}
          onClick={() => showModal(text)}
        >
          {text.length > 30 ? text.slice(0, 30) + "..." : text}
        </p>
      ),
    },
    // {
    //   title: 'Description',
    //   dataIndex: 'description',
    //   key: 'description',
    //   render: (text) => <p className="cap">{text}</p>,
    // },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <>
          <Button className="edit-btn-table" icon={<img src={EditTableIcon} alt="Edit" />} onClick={() => handleEditContent(record)} />
          <Button
            className="edit-btn-table"
            icon={<DownloadOutlined />}
            onClick={() => handleDownload(record)}
            style={{ marginLeft: 8 }}
          >
          </Button>

          {/* Add Delete button as needed */}
        </>
      )
    }
  ];

  const handleDownload = (record) => {
    // 1. Download the image or document
    if (record.image) {
      const link1 = document.createElement('a');
      link1.href = record.image;
      link1.download = record.image.split('/').pop(); // Extract filename
      link1.target = '_blank';
      link1.rel = 'noreferrer';
      document.body.appendChild(link1);
      link1.click();
      document.body.removeChild(link1);
    }

    // 2. Download the description as a text file
    const blob = new Blob([record.description], { type: 'text/plain' });
    const link2 = document.createElement('a');
    link2.href = URL.createObjectURL(blob);
    link2.download = 'description.txt';
    document.body.appendChild(link2);
    link2.click();
    document.body.removeChild(link2);
  };

  // Fetch content function
  const fetchContent = () => {
    setLoading(true);
    request({
      url: apiPath.getContent,
      method: "GET",
      onSuccess: (data) => {
        if (data.status) {
          setDataSource(data.data.data);
        } else {
          message.error(data.message || "Failed to fetch content");
        }
        setLoading(false);
      },
      onError: (error) => {
        message.error(error?.message || "An error occurred while fetching content");
        setLoading(false);
      },
    });
  };

  useEffect(() => {
    fetchContent();
  }, []);

  // Upload to S3 helper
  // const uploadFileToS3 = async (file) => {
  //   const key = "sala-chat/content/" + file.name;
  //   const params = {
  //     Bucket: 'invent-co-new',
  //     Key: key,
  //     Body: file,
  //   };

  //   const upload = new Upload({
  //     client: s3Client,
  //     params: params,
  //   });

  //   try {
  //     const data = await upload.done();
  //     return data;
  //   } catch (err) {
  //     throw err;
  //   }
  // };

  // // Add modal: upload handler
  // const handleChange = async ({ file }) => {
  //   if (!file) return;

  //   try {
  //     const data = await uploadFileToS3(file.originFileObj || file);
  //     const fileData = {
  //       uid: file.uid,
  //       name: file.name,
  //       status: 'done',
  //       url: data.Location,
  //       thumbUrl: data.Location,
  //       type: file.type,
  //     };
  //     setFile([fileData]); // Replace previous file with new one
  //     form.setFieldsValue({ image: data.Location });
  //     setText(form.getFieldValue("description") || "");
  //   } catch (err) {
  //     message.error("Upload failed");
  //     console.error(err);
  //   }
  // };

  const uploadFileToS3 = async (file, bucketName) => {
    const key = "sala-chat/content/" + file.name
    const params = {
      Bucket: bucketName,
      Key: key,
      Body: file,
    };

    const upload = new Upload({
      client: s3Client,
      params: params,
    });

    try {
      const data = await upload.done();
      console.log(data, "line 47");
      return data;
    } catch (err) {
      throw err;
    }
  };
  const handleChange = async (event) => {
    const { file } = event;
    setFile([file]);
    try {
      const data = await uploadFileToS3(file, 'invent-co-new');
      const fileData = {
        uid: file.uid,
        name: file.name,
        status: 'done',
        url: data.Location,
        thumbUrl: data.Location,
      };
      setFile([fileData]);
      form.setFieldsValue({ image: data.Location });
      console.log(data, "line 83");
    } catch (err) {
      console.error(err);
    }
  };

  // Add modal: remove handler
  const onRemove = () => {
    setFile([]);
    form.setFieldsValue({ image: null });
  };

  // Submit for Add modal
  const handleSubmit = () => {
    form.validateFields().then(async (values) => {
      const plainTextDescription = stripHtml(values.description);
      // if (!file.length) {
      //   message.error("Please upload a file before submitting");
      //   return;
      // }
      setLoading(true);
      request({
        url: apiPath.createContent,
        method: "POST",
        data: {
          description: values.websiteUrl ? values.websiteUrl : plainTextDescription,
          image: file.length > 0 ? file[0].url : ""
        },
        onSuccess: (data) => {
          setLoading(false);
          if (data.status) {
            message.success("Content added successfully!");
            fetchContent();
            setFile([]);
            form.resetFields();
            setText("");
            setIsModalOpen(false);
            setIsModalWebsiteOpen(false);
          } else {
            message.error(data.message || "Failed to add content");
            
          }
        },
        onError: (error) => {
          setLoading(false);
          message.error(error?.message || "An error occurred while adding content");
        }
      });
    });
  };

  // Edit modal upload handler (same logic as Add)
  const handleChangeEdit = async ({ file }) => {
    if (!file) return;

    try {
      const data = await uploadFileToS3(file.originFileObj || file);
      const fileData = {
        uid: file.uid,
        name: file.name,
        status: 'done',
        url: data.Location,
        thumbUrl: data.Location,
        type: file.type,
      };
      setFileEdit([fileData]); // Replace old file
      setImageEdit(data.Location);
      form1.setFieldsValue({ image: data.Location });
    } catch (err) {
      message.error("Upload failed");
      console.error(err);
    }
  };

  // Edit modal remove handler
  const onRemoveEdit = () => {
    setFileEdit([]);
    setImageEdit("");
    form1.setFieldsValue({ image: null });
  };

  // Edit content submit handler
  const handleEditSubmit = () => {
    // console.log(values, "values")
    form1.validateFields().then((values) => {
      const plainTextDescription = stripHtml(values.description);
      // if (!fileEdit.length && !imageEdit) {
      //   message.error("Please upload a file before submitting");
      //   return;
      // }
      setLoading(true);
      // assuming selectedContent is set on edit
      request({
        url: `${apiPath.editContent}/${selectedContent._id}`,
        method: "PUT",
        data: {
          description: plainTextDescription,
          image: file.length > 0 ? file[0].url : ""
          // image: file[0]?.url || imageEdit
        },
        onSuccess: (data) => {
          setLoading(false);
          if (data.status) {
            message.success("Content updated successfully!");
            fetchContent();
            setFileEdit([]);
            setImageEdit("");
            form1.resetFields();
            setEditOpen(false);
          } else {
            message.error(data.message || "Failed to update content");
          }
        },
        onError: (error) => {
          setLoading(false);
          message.error(error?.message || "An error occurred while updating content");
        },
      });
    });
  };

  // Edit modal show handler
  const [selectedContent, setSelectedContent] = useState(null);
  const handleEditContent = (record) => {
    setSelectedContent(record);
    form1.setFieldsValue({
      description: record.description,
      image: record.image,
    });
    setImageEdit(record.image);
    setFileEdit([]); // Clear fileEdit on open, show existing image from imageEdit
    setEditOpen(true);
  };

  return (
    <>
      <div className="page-top-space home-card layout-content">
        <Row gutter={[24, 24]}>
          <Col xs={24}>
            <Card
              title="Content Manager"
              extra={
             <>
                <Button type="primary" className="fill-btn" onClick={() => setIsModalOpen(true)}>
                  <PlusOutlined />   Add Content
                </Button>
                {/* <Button type="primary" className="fill-btn" onClick={() => setIsModalWebsiteOpen(true)}>
                  <PlusOutlined />   Add Website Content
                </Button> */}
             
             </>

                
              }
            >
              <Table
                columns={columns}
                dataSource={dataSource}
                rowKey="_id"
                loading={loading}
              />

            </Card>
          </Col>
        </Row>
        <Modal
          className="tab_modal"
          // title="Full Description"
          centered  // 👈 This makes modal open in the center of the screen
          open={isModalContentOpen}
          onCancel={handleCancel}
          footer={null}
        >
          <p>{modalContent}</p>
        </Modal>

        {/* Add Modal */}
        <Modal
          title="Add Content"
          open={isModalOpen}
          className="tab_modal"
          onCancel={() => {
            setIsModalOpen(false);
            form.resetFields();
            setFile([]);
            setText("");
          }}
          footer={[
            <Button key="cancel" onClick={() => {
              setIsModalOpen(false);
              setFile([]);
            }}>
              Cancel
            </Button>,
            <Button
              key="submit"
              type="primary"
              loading={loading}
              onClick={handleSubmit}
            >
              Submit
            </Button>,
          ]}
          width={800}
          centered
        >
          <Form
            className="mt-3"
            form={form}
            layout="vertical"
            initialValues={{ description: "", image: null }}
          >
            <Form.Item
              label="Description"
              name="description"
              rules={[
                {
                  validator: (_, value) => {
                    if (!value || !stripHtml(value).trim()) {
                      return Promise.reject("Description is required");
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <ReactQuill
                value={text}
                onChange={(value) => {
                  setText(value);
                  form.setFieldsValue({ description: value });
                }}
                placeholder="Enter Description here"
              />
            </Form.Item>
            <div className="main-new-upload-new-ikj9-plkm">
              <Form.Item
                label="Upload File"
                name="image"
              // rules={[{ required: true, message: "Please upload a file!" }]}
              >
                <UploadAntd
                  className="public-upload public-upload-new-main"
                  listType="picture"
                  maxCount={1}
                  // beforeUpload={beforeUpload}
                  customRequest={handleChange}
                  fileList={file}
                  onRemove={onRemove}
                >
                  <Button>
                    <img src={UploadIcon} alt="upload" />
                    Upload
                  </Button>
                </UploadAntd>
                {/* <UploadAntd
                accept="image/*,application/pdf"
                customRequest={() => {}} // We handle upload manually
                onChange={handleChange}
                onRemove={onRemove}
                fileList={file}
                maxCount={1}
                listType="picture"
              >
                {file.length >= 1 ? null : (
                  <Button icon={<PlusOutlined />}>Upload</Button>
                )}
              </UploadAntd> */}
              </Form.Item>
              <div className="main-new-upload-new-ikj9-plkm-size-in-mb">
                <h3>TYPE: JPG, PNG, PDF</h3>
                <h3>SIZE: MAX 5MB</h3>
              </div>
            </div>
          </Form>
        </Modal >

        {/* Edit Modal */}
        < Modal
          title="Edit Content"
          open={editOpen}
          className="tab_modal"
          onCancel={() => {
            setEditOpen(false);
            form1.resetFields();
            setFileEdit([]);
            setImageEdit("");
            setFile([]);
          }
          }
          footer={
            [
              <Button key="cancel" onClick={() => {
                setEditOpen(false);
                setFile([]);
              }}>
                Cancel
              </Button>,
              <Button
                key="submit"
                type="primary"
                loading={loading}
                onClick={handleEditSubmit}
              >
                Submit
              </Button>,
            ]}
          width={800}
          centered
        >
          <Form
            form={form1}
            layout="vertical"
            initialValues={{ description: "", image: null }}
          >
            <Form.Item
              label="Description"
              name="description"
              rules={[
                {
                  validator: (_, value) => {
                    if (!value || !stripHtml(value).trim()) {
                      return Promise.reject("Description is required");
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <ReactQuill
                value={form1.getFieldValue("description")}
                onChange={(value) => {
                  form1.setFieldsValue({ description: value });
                }}
                placeholder="Enter Description here"
              />
            </Form.Item>

            <Form.Item
              label="Upload File"
              name="image"
            // rules={[{ required: true, message: "Please upload a file!" }]}
            >
              {/* <UploadAntd
                className="public-upload"
                listType="picture"
                maxCount={1}
                // beforeUpload={beforeUpload}
                customRequest={handleChange}
                fileList={file}
                onRemove={onRemove}
              >
                <Button>
                  <img src={UploadIcon} alt="upload" />
                  Upload
                </Button>

              </UploadAntd> */}







              <UploadAntd
                // accept="image/*,application/pdf"
                className="public-upload"
                listType="picture"
                maxCount={1}
                customRequest={handleChange}
                // onChange={handleChangeEdit}
                onRemove={onRemoveEdit}
                fileList={file.length ? file : (imageEdit ? [{
                  uid: '-1',
                  name: 'Current File',
                  status: 'done',
                  url: imageEdit,
                  thumbUrl: imageEdit,
                }] : [])}

              >
                {(file.length === 0 && !imageEdit) ? (
                  <Button icon={<PlusOutlined />}>Upload</Button>
                ) : null}
              </UploadAntd>
            </Form.Item>
          </Form>
        </Modal >


        <Modal
          title="Add Content"
          open={isModalWebsiteOpen}
          className="tab_modal"
          onCancel={() => {
            setIsModalWebsiteOpen(false);
            form.resetFields();
            setFile([]);
            setText("");
          }}
          footer={[
            <Button key="cancel" onClick={() => {
              setIsModalOpen(false);
              setFile([]);
            }}>
              Cancel
            </Button>,
            <Button
              key="submit"
              type="primary"
              loading={loading}
              onClick={handleSubmit}
            >
              Submit
            </Button>,
          ]}
          width={800}
          centered
        >
          <Form
            className="mt-3"
            form={form}
            layout="vertical"
            initialValues={{ websiteUrl: "", image: null }}
          >
            <Form.Item
              label="Website URL"
              name="websiteUrl"
              rules={[
                {
                  validator: (_, value) => {
                    if (!value || !stripHtml(value).trim()) {
                      return Promise.reject("Website URL is required");
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Input placeholder="Enter Website URL here" />
            </Form.Item>
          
          </Form>
        </Modal >

      </div >
    </>
  );
}

export default Home;
